import Swiper, { Navigation}  from "swiper";

Swiper.use([Navigation]);
/**
 * OfficeBrowserSlider class
 */
export default class OfficeBrowserSlider {
    constructor() {
        /**
         *
         * @type {{slider: string, sliderNext: string, sliderPrev: string, sliders: string}}
         */
        this.defaults = {
            //elements
            sliders: ".js-office-browser-slider-wrapper",
            slider: ".js-slider",
            sliderNext: ".js-slider-next",
            sliderPrev: ".js-slider-prev",
        };
    }

    //region methods
    /**
     * OfficeBrowserSlider class init method and init flag
     */
    init() {
        console.log("OfficeBrowserSlider init()");

        const sliders = document.querySelectorAll(this.defaults.sliders);

        if (sliders.length > 0) {
            this.sliderController(sliders);
        }
    }

    sliderController(sliders) {
        sliders.forEach((sliderWrapper) => {
            const slider = sliderWrapper.querySelector(this.defaults.slider);
            const swiper = new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                speed: 600,
                observer: true,
                observeParents: true,
                parallax:true,
                shortSwipes: true,
                navigation: {
                    nextEl: sliderWrapper.querySelector(this.defaults.sliderNext),
                    prevEl: sliderWrapper.querySelector(this.defaults.sliderPrev),
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    renderBullet: function (index, className) {
                        if (this.slides[index]) {
                            const title = this.slides[index].dataset.slideTitle;

                            if (title !== "" && title != null) {
                                return `<span class="u-b1 js-fade-small ${className}">${title}<svg class="u-icon u-icon--arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 7"><path d="M0 4h6.3L4 6.4l.7.6L8 3.5 4.7 0 4 .6 6.3 3H0v1z"></path></svg></span>`;
                            }
                        }
                    },
                },
                breakpoints: {
                    200: {
                        spaceBetween: 15,
                    },
                    600: {
                        shortSwipes: false,
                        spaceBetween: 30,
                    },
                }
            });

            if (swiper.slides.length < 2) {
                sliderWrapper.querySelector(this.defaults.sliderNext).style.display = "none";
                sliderWrapper.querySelector(this.defaults.sliderPrev).style.display = "none";
            }
        });
    }

    //endregion
}
